import { Component, Directive, Input, TemplateRef, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver } from '@angular/core';
import { LoadState } from './loader.module';
@Component({
    selector: 'loading-spinner',
    template: `<div class="loading">
              </div>`
})
export class LoadingPendingComponent {

    constructor() { }
}
@Component({
    selector: 'loading-spinner',
    template: `<div class="loading">
                <mat-spinner [diameter]="50"></mat-spinner>
              </div>`,
    styles: [
        `
    .loading{
      display: flex;
      justify-content: center;
      padding: 16px;
    }
    `
    ]
})
export class LoadingSpinnerComponent {

    constructor() { }
}
@Component({
    selector: 'loading-error',
    template: `<div class="error">
                Oops, something went wrong, Analytics can’t be currently loaded
              </div>`,
    styles: [
        `
        .error{
            display: flex;
            justify-content: center;
            color: #5a5a5a;
            padding: 16px;
        }
        `
    ]
})
export class LoadingErrorComponent {

    constructor() { }
}

@Component({
    selector: 'loading-empty',
    template: `<div class="empty">
                No activity to show
              </div>`,
    styles: [
        `
        .empty{
            display: flex;
            justify-content: center;
            color: #5a5a5a;
            padding: 16px;
        }
        `
    ]
})
export class LoadingEmptyComponent {

    constructor() { }
}
@Directive({
    selector: '[loading]',
    inputs: ['loading']
})
export class LoadingDirective {
    loadingSpinnerFactory: ComponentFactory<LoadingSpinnerComponent>;
    loadingErrorFactory: ComponentFactory<LoadingErrorComponent>;
    loadingPendingFactory: ComponentFactory<LoadingPendingComponent>;
    loadingEmptyFactory: ComponentFactory<LoadingEmptyComponent>;
    loadingComponent: ComponentRef<LoadingSpinnerComponent>;

    @Input()
    set loading(loading: string) {
        this.vcRef.clear();
        switch (loading) {
            case LoadState.pending:
                this.loadingComponent = this.vcRef.createComponent(this.loadingPendingFactory);
                break;
            case LoadState.loading:
                this.loadingComponent = this.vcRef.createComponent(this.loadingSpinnerFactory);
                break;
            case LoadState.error:
                this.loadingComponent = this.vcRef.createComponent(this.loadingErrorFactory);
                break;
            case LoadState.empty:
                this.loadingComponent = this.vcRef.createComponent(this.loadingEmptyFactory);
                break;
            case LoadState.completed:
                this.vcRef.createEmbeddedView(this.templateRef);
                break;
            default:
                break;
        }
    }

    constructor(private templateRef: TemplateRef<any>, private vcRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {
        // Create resolver for loading component
        this.loadingSpinnerFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingSpinnerComponent);
        this.loadingErrorFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingErrorComponent);
        this.loadingPendingFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingPendingComponent);
        this.loadingEmptyFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingEmptyComponent);
    }
}


